import "../css/moodboard-masonry.css";
import ItemBar from "./ItemBar/ItemBar";

function isLinkedInEmbedUrl(url) {
  return url && url.includes("linkedin.com/embed/");
}

function TileLinkedIn({ currentFile, view, rateAssetService, ...props }) {
  const url = currentFile?.fileUrl;

  return (
    <div className={`tile ${props.id}`}>
      <ItemBar
        currentFile={currentFile}
        viewItem={() => view(currentFile._id)}
        deleteItem={() => props.delete(currentFile._id)}
        rateAssetService={rateAssetService}
      />
      {url && isLinkedInEmbedUrl(url) ? (
        <div style={{ padding: "8px" }}>
          <iframe
            src={url}
            height="399"
            width="100%"
            frameBorder="0"
            allowFullScreen
            title="LinkedIn Post"
            style={{ border: "none", borderRadius: "8px" }}
          />
        </div>
      ) : url ? (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none" }}
        >
          <div
            style={{
              backgroundColor: "#1a1a2e",
              border: "1px solid #333",
              borderRadius: "8px",
              padding: "20px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              minHeight: "200px",
              gap: "12px",
              cursor: "pointer",
            }}
          >
            <img
              src="https://static.licdn.com/aero-v1/sc/h/al2o9zrvru7aqj8e1x2rzsrca"
              alt="LinkedIn"
              style={{ width: "48px", height: "48px" }}
            />
            <span style={{ color: "#0a66c2", fontWeight: "600", fontSize: "16px" }}>
              LinkedIn Post
            </span>
            <span style={{ color: "#888", fontSize: "13px" }}>
              Click to view on LinkedIn
            </span>
          </div>
        </a>
      ) : null}
    </div>
  );
}

export default TileLinkedIn;
